import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { competitorTypes, getCompetitorTypeBySport } from "../config/competitorTypes";
import { PermissionNames } from "~enums/permissions";

const usePermissionsByCompetitionName = () => {
  const { sport } = useParams();

  const competitionType = useMemo(() => {
    return getCompetitorTypeBySport(sport);
  }, [sport]);

  const entityPermissionName = useMemo(() => {
    switch (competitionType) {
      case competitorTypes.ENTITY:
        return PermissionNames.ENTITY;
      case competitorTypes.PERSON:
        return PermissionNames.PERSON;
      default:
        throw new Error("Invalid competitor type");
    }
  }, [competitionType]);

  const seasonEntityPermissionName = useMemo(() => {
    switch (competitionType) {
      case competitorTypes.ENTITY:
        return PermissionNames.SEASON_ENTITY;
      case competitorTypes.PERSON:
        return PermissionNames.SEASON_PERSON;
      default:
        throw new Error("Invalid competitor type");
    }
  }, [competitionType]);

  const fixturePermissionName = useMemo(() => {
    switch (competitionType) {
      case competitorTypes.ENTITY:
        return PermissionNames.FIXTURE_ENTITY;
      case competitorTypes.PERSON:
        return PermissionNames.FIXTURE_PERSON;
      default:
        throw new Error("Invalid competitor type");
    }
  }, [competitionType]);

  return { fixturePermissionName, entityPermissionName, seasonEntityPermissionName };
};

export default usePermissionsByCompetitionName;
